export default __webpack_public_path__ + "static/media/voicenote-screenshot-05.f07bc13f.png";